"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var _react = require("react");

var React = _interopRequireWildcard(_react);

var _selectn = require("selectn");

var _selectn2 = _interopRequireDefault(_selectn);

var _lodash = require("lodash");

var _reactScroll = require("react-scroll");

var _reactIntl = require("react-intl");

var _actions = require("../../reducers/user/actions");

var userActions = _interopRequireWildcard(_actions);

var _actions2 = require("../../reducers/reportDetail/actions");

var reportDetailActions = _interopRequireWildcard(_actions2);

var _reactCssModules = require("react-css-modules");

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _TCombFormWrapper = require("../../../components/TCombFormWrapper");

var _TCombFormWrapper2 = _interopRequireDefault(_TCombFormWrapper);

var _tcombForm = require("tcomb-form");

var _tcombForm2 = _interopRequireDefault(_tcombForm);

var _reactRedux = require("react-redux");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var Form = _tcombForm2.default.form.Form;
var styles = require("./ReportDetailTypeContent.less");

var debouncedValidationFunction = (0, _lodash.debounce)(function (component, reportStepIds) {
    var tempRefs = component.refs;
    (0, _lodash.chain)(reportStepIds).forEach(function (reportStepId) {
        var form = tempRefs["form" + reportStepId];
        if (form) {
            (function () {
                var validate = form.getForm().validate();
                var isValid = validate.errors.length === 0;
                (0, _lodash.chain)(component.props.reportDetail.reportStepData).forEach(function (reportStepData) {
                    // only disptch if validation state changed
                    if (reportStepData.stepDefinition.uid === reportStepId && isValid !== reportStepData.isValid) {
                        component.props.dispatch(reportDetailActions.validationStateOfStepChanged(reportStepData, isValid));
                        return false;
                    }
                }).value();
            })();
        }
    }).value();
}, 500);
var ReportDetailSteps = function (_React$Component) {
    _inherits(ReportDetailSteps, _React$Component);

    function ReportDetailSteps(props) {
        _classCallCheck(this, ReportDetailSteps);

        var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ReportDetailSteps).call(this, props));

        _this.onSaveButtonPressed = function () {
            _this.setState({ hideError: false });
        };
        _this.onFormChange = function (data, reportStepId) {
            _this.props.dispatch(reportDetailActions.updateReportWithStepFormData(reportStepId, data));
            return;
        };
        _this.onFormSubmit = function (e, reportStepId) {
            // this.props.dispatch(reportDetailActions.saveSelectedReport());
            return;
        };
        _this.onSaveForm = function () {
            return;
        };
        _this.setupForm = function (reportStepData, isOwnReport, isManager, isSharedWithUser) {
            var schema = null;
            var schemaOptions = {};
            var currentFormData = {};
            var formatMessage = _this.props.intl.formatMessage;

            var disabled = false;
            if (_this.props.reportDetail.selectedReport.state === "approved") {
                disabled = true;
            } else if (_this.props.reportDetail.selectedReport.state === "open") {
                if (reportStepData.stepDefinition.type === "closingManager") {
                    disabled = true;
                } else {
                    disabled = !isOwnReport && !isSharedWithUser;
                }
            } else if (_this.props.reportDetail.selectedReport.state === "closed") {
                if (isManager && reportStepData.stepDefinition.type === "closingManager") {
                    disabled = false;
                } else {
                    disabled = true;
                }
            }
            (0, _lodash.chain)(reportStepData.fields).forEach(function (field) {
                var appSchemaStruct = field.appDataField.appSchemaStruct();
                if (!schema) {
                    schema = appSchemaStruct;
                } else {
                    schema = schema.extend(appSchemaStruct);
                }
                var appSchemaOptionsFieldsObject = field.appDataField.appSchemaFieldOptions(formatMessage, disabled);
                schemaOptions = Object.assign({}, schemaOptions, appSchemaOptionsFieldsObject);
                (0, _lodash.set)(currentFormData, field.appDataField.key(), field.appDataField.currentFormValue());
            }).value();
            return {
                formData: currentFormData,
                schema: schema,
                schemaOptions: { fields: schemaOptions }
            };
        };
        _this.state = {
            hideError: true
        };
        return _this;
    }

    _createClass(ReportDetailSteps, [{
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.stepUid !== this.props.stepUid) {
                var options = {
                    smooth: false,
                    isDynamic: true,
                    containerId: "stepContainer"
                };
                _reactScroll.scroller.scrollTo(nextProps.stepUid, options);
            }
        }
    }, {
        key: "componentDidMount",
        value: function componentDidMount() {
            // this.props.onSaveButtonPressed(this.onSaveButtonPressed);
            if (!this.props.user.appUserProfile) {
                this.props.dispatch(userActions.loadUserProfile());
            }
            if (this.props.reportDetail.reportStepData) {
                var reportStepDataIds = (0, _lodash.chain)(this.props.reportDetail.reportStepData).map(function (reportStepData) {
                    return reportStepData.stepDefinition.uid;
                }).value();
                debouncedValidationFunction(this, reportStepDataIds);
                _reactScroll.scroller.scrollTo(this.props.stepUid, {
                    smooth: false,
                    isDynamic: true,
                    containerId: "stepContainer"
                });
            }
        }
    }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate() {
            var filter = null;
            if (this.props.reportDetail.reportStepData) {
                var reportStepDataIds = (0, _lodash.chain)(this.props.reportDetail.reportStepData).map(function (reportStepData) {
                    return reportStepData.stepDefinition.uid;
                }).value();
                debouncedValidationFunction(this, reportStepDataIds);
            }
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            var forms = null;
            if (this.props.reportDetail.selectedReportDefinition && this.props.reportDetail.selectedReport) {
                (function () {
                    var formattedMessage = _this2.props.intl.formattedMessage;

                    var form = null;
                    var permission = _this2.props.auth.highestPermission;
                    var uid = (0, _selectn2.default)("appUserProfile.uid", _this2.props.user);
                    var isManager = permission !== "user";
                    var isOwnReport = uid === _this2.props.reportDetail.selectedReport.userUid;
                    var isSharedWithUser = _this2.props.reportDetail.selectedReport.sharedWith.indexOf(_this2.props.user.appUserProfile.UserId) !== -1;
                    forms = (0, _lodash.chain)(_this2.props.reportDetail.reportStepData).filter(function (stepData) {
                        if (isManager) {
                            if (!isOwnReport) {
                                return stepData.stepDefinition.type !== "closingUser";
                            } else {
                                return true;
                            }
                        } else {
                            return stepData.stepDefinition.type !== "closingManager";
                        }
                    }).map(function (reportStep) {
                        var _setupForm = _this2.setupForm(reportStep, isOwnReport, isManager, isSharedWithUser);

                        var formData = _setupForm.formData;
                        var schema = _setupForm.schema;
                        var schemaOptions = _setupForm.schemaOptions;

                        if (schema && schemaOptions) {
                            var title = React.createElement("h1", null, reportStep.stepDefinition.title);
                            var contingentInformation = null;
                            if (reportStep.stepDefinition.type === "closingManager") {
                                title = React.createElement("h1", null, React.createElement(_reactIntl.FormattedMessage, { id: "reportStep.type.closingManager" }));
                                contingentInformation = React.createElement("h4", null, React.createElement(_reactIntl.FormattedMessage, { id: "reportStep.type.closingManager.contingent" }), " ", _this2.props.reportDetail.contingent);
                            } else if (reportStep.stepDefinition.type === "closingUser") {
                                title = React.createElement("h1", null, React.createElement(_reactIntl.FormattedMessage, { id: "reportStep.type.closingUser" }));
                            }
                            return React.createElement(_reactScroll.Element, { key: reportStep.stepDefinition.uid, name: reportStep.stepDefinition.uid }, title, React.createElement(_TCombFormWrapper2.default, { onSubmit: function onSubmit(e) {
                                    return _this2.onFormSubmit(e, reportStep.stepDefinition.uid);
                                }, ref: "form" + reportStep.stepDefinition.uid, type: schema, options: schemaOptions, value: formData, onChange: function onChange(data) {
                                    return _this2.onFormChange(data, reportStep.stepDefinition.uid);
                                } }), contingentInformation);
                        } else {
                            console.log("no schema, no schema options");
                        }
                    }).value();
                })();
            }
            return React.createElement("div", { styleName: "content", className: this.props.showErrors ? "" : "hide-error", style: { overflowX: "scroll" }, id: "stepContainer" }, forms);
        }
    }]);

    return ReportDetailSteps;
}(React.Component);
ReportDetailSteps = __decorate([_reactIntl.injectIntl, (0, _reactRedux.connect)(function (state) {
    return {
        reportDetail: state.reportDetail,
        user: state.user,
        auth: state.auth
    };
}), (0, _reactCssModules2.default)(styles)], ReportDetailSteps);
exports.default = ReportDetailSteps;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/containers/reportDetail/ReportDetailSteps.tsx
 ** module id = 1280
 ** module chunks = 0
 **/